import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IssueTypeComponent } from './component/issue-type.component';

import { MaterialModule } from '@sdbn/appclient';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/appclient';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    MaterialModule,
    DictionaryModule,
    CommonTranslationModule,
    ApplicationClientCommonModule
  ],
  declarations: [IssueTypeComponent]

})
export class IssueTypeModule { }

